import Vue from "vue";
import config from "./api-config";
import { EncryptionService } from "./esencryption";

export default class TokenWebsite {
  public async gettokenwebsite() {
    const Usernamevalue = "encryptedmobileappsuser@pgc.edu.pk";
    const Passwordvalue = "m#P52s@ap$VP@kht00nKhw@hm#P52s@ap$VP@kht00nKhw@h";
    const userloginData = localStorage.getItem("elp_plus_username");
    const DevieId = "";
    const DeviceIP = "";
    const LoginWith = "Web";

    const configCMS = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };
    var uname = EncryptionService.encrypt(Usernamevalue);
    var upass = EncryptionService.encrypt(Passwordvalue);
    var ulogin = EncryptionService.encrypt(userloginData ?? '');
    var devieId = EncryptionService.encrypt(DevieId);
    var deviceip = EncryptionService.encrypt(DeviceIP);
    var loginwith = EncryptionService.encrypt(LoginWith);
    try {
      const requestBody = {
        UserName: uname,
        Password: upass,
        UserEmail: ulogin,
        DeviceId: devieId,
        DeviceIP: deviceip,
        LoginWith: loginwith,
      };
      const response = await Vue.axios.post(
        "https://ems.pgc.edu.pk/auth/TokenWebSite",
        requestBody
      );
      if (response.status !== 200) {
        throw new Error(response.data?.message || "Login API error");
      }
      let decryptedData;
      if (response.data?.data) {
        const decryptedBody = EncryptionService.decrypt(response.data.data);
        decryptedData = JSON.parse(decryptedBody);
      } else {
        decryptedData = response.data;
      }
      return decryptedData;
    } catch (error) {
      throw error;
    }
  }

  public getJwtToken(): string {
    const jwtResponse = localStorage.getItem('jwtToken');

    if (!jwtResponse) {
      throw new Error('JWT token not found in localStorage');
    }

    return jwtResponse;
  }



  public async getStudentInfoEMS_Encrypt(Id: string) {
    const jwtToken = localStorage.getItem('jwtToken');
    const configCMS = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${jwtToken}`,
      },
    };
    var payload = Id.indexOf('@') !== -1 ? Id.split('@')[0] : Id;
    const bodyEncrypt = EncryptionService.encrypt(payload);
    const requestBody = { Student_ID: bodyEncrypt };
    const response = await Vue.axios.post(config.getStudentInfoEMS_Encrypt, requestBody, configCMS);
    var body = await response.data;
    const bodyDecrypt = EncryptionService.decrypt(body.data);
    body.data = JSON.parse(bodyDecrypt);
    if (response.status !== 200) {
      throw Error(body.message);
    }
    return body;
  }

}
